module.exports = __webpack_public_path__ + "static/001-2348c5f47149110b79f035603fea676a.jpg";